import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { isetSyncService } from "./services/isetSyncService";

// Inicializa o background sync para a integração iSET
isetSyncService.startBackgroundSync();

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
